import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { LOADING } from '../../../redux_store/actionTypes'
import LoadingModal from '../../templates/modals/LoadingModal'
import Button from '../../templates/Button'
import { DatabaseScript, Plus, Gift } from 'iconoir-react'
import { getAllPromotions } from '../../../redux_store/promotions/promotion_thunk'
import moment from 'moment'

const PromotionsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { promotions, status } = useSelector((state) => state.promotion);

  useEffect(() => {
    dispatch(getAllPromotions());
    // eslint-disable-next-line
  }, []);

  return (
    <div className='space-y-6'>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}

      {/* Page Header */}
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-2xl font-bold text-surface-800'>Promotions</h1>
          <p className='text-surface-500 mt-1'>Manage promo codes and discounts</p>
        </div>
        <div className='flex items-center gap-3'>
          <Button
            onClick={() => navigate('/promotions/applied/')}
            label={'Applied Promos'}
            variant="secondary"
            icon={<DatabaseScript strokeWidth={2} className='w-4 h-4' />}
          />
          <Button
            onClick={() => navigate('/promotions/create')}
            label={'Add Promo'}
            variant="primary"
            icon={<Plus strokeWidth={2} className='w-4 h-4' />}
          />
        </div>
      </div>

      {/* Promotions Table */}
      <div className='card p-0 overflow-hidden'>
        <table className="table-modern">
          <thead>
            <tr>
              <th>Promo Code</th>
              <th>Promo Type</th>
              <th>Value</th>
              <th>Expiry Date</th>
              <th>Total Usage</th>
            </tr>
          </thead>
          <tbody>
            {promotions && promotions.length > 0 ?
              promotions.map((promo, index) =>
                <tr key={promo.id || index}>
                  <td>
                    <span className='font-mono font-semibold text-surface-800 bg-surface-100 px-3 py-1 rounded-lg'>
                      {promo.promo_code}
                    </span>
                  </td>
                  <td>
                    <span className='badge-info'>
                      {promo.promo_type}
                    </span>
                  </td>
                  <td className='font-semibold text-surface-800'>
                    {promo.promo_type === 'Percentage' ? `${promo.value}%` : `GH₵ ${promo.value}`}
                  </td>
                  <td>
                    {moment(promo.expiry_date).format('MMM D, YYYY')}
                  </td>
                  <td>
                    <span className='badge bg-surface-100 text-surface-600'>
                      {promo.total_usage} uses
                    </span>
                  </td>
                </tr>
              ) :
              <tr>
                <td colSpan={5} className="text-center py-12">
                  <div className='flex flex-col items-center gap-3'>
                    <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                      <Gift strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                    </div>
                    <div>
                      <p className='font-medium text-surface-600'>No promotions found</p>
                      <p className='text-sm text-surface-400'>Create your first promo code</p>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PromotionsPage
